import { render } from "./MainBlock.vue?vue&type=template&id=6d70eed5&scoped=true"
import script from "./MainBlock.vue?vue&type=script&lang=js"
export * from "./MainBlock.vue?vue&type=script&lang=js"

import "./MainBlock.vue?vue&type=style&index=0&id=6d70eed5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d70eed5"]])

export default __exports__